import { render, staticRenderFns } from "./PointEarningRuleList.vue?vue&type=template&id=22fed7a1&scoped=true&"
import script from "./PointEarningRuleList.vue?vue&type=script&lang=js&"
export * from "./PointEarningRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fed7a1",
  null
  
)

export default component.exports